import { render, staticRenderFns } from "./WeekBody.vue?vue&type=template&id=70c317a1&"
import script from "./WeekBody.vue?vue&type=script&lang=js&"
export * from "./WeekBody.vue?vue&type=script&lang=js&"
import style0 from "./WeekBody.vue?vue&type=style&index=0&id=70c317a1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports